import React from "react";
import { Download, Eye, Search } from "lucide-react";
import Pagination from "./Pagination";
import { fmtDate, statusClass } from "../utils/inventory.helpers";

export default function InboundSection({
  receiptFilter,
  setReceiptFilter,
  loadInbound,
  loading,
  paginatedReceipts,
  receiptsPage,
  receiptsTotalPages,
  setReceiptsPage,
  openReceipt,
  warehouseInventoryService,
}) {
  return (
    <>
      <div className="flex items-center gap-3">
  <div className="relative">
    <select
      value={receiptFilter}
      onChange={(e) => setReceiptFilter(e.target.value)}
      className="appearance-none rounded-[12px] border border-[#f2c6cc] bg-white px-4 py-2 pr-10 text-[14px] font-medium text-slate-700 shadow-sm outline-none transition focus:border-[#d86a78] focus:ring-2 focus:ring-[#fbe3e6]"
    >
      <option value="">All statuses</option>
      <option value="pending">Pending</option>
      <option value="approved">Approved</option>
      <option value="received">Received</option>
      <option value="cancelled">Cancelled</option>
    </select>

    {/* custom arrow */}
    <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-slate-400">
      ▼
    </div>
  </div>
</div>

      <div className="rounded-[20px] border border-[#f2c6cc] bg-white shadow-[0_12px_30px_rgba(216,106,120,0.08)]">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[980px]">
            <thead className="bg-[#fff7f8]">
              <tr className="text-left text-[13px] font-semibold text-slate-600">
                <th className="px-5 py-4">Receipt</th>
                <th className="px-5 py-4">Status</th>
                <th className="px-5 py-4">Source</th>
                <th className="px-5 py-4">Created</th>
                <th className="px-5 py-4">Received</th>
                <th className="px-5 py-4 text-right">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={6} className="px-5 py-8 text-center text-[14px] text-slate-500">
                    Loading receipts...
                  </td>
                </tr>
              ) : paginatedReceipts.length ? (
                paginatedReceipts.map((item) => (
                  <tr key={item.id} className="border-t border-[#f8dde1] text-[14px] text-slate-700">
                    <td className="px-5 py-4">
                      <div className="font-semibold text-slate-800">
                        {item.receiptCode ||
                          `INB-${String(item.id).replace(/-/g, "").slice(0, 8).toUpperCase()}`}
                      </div>
                    </td>

                    <td className="px-5 py-4">
                      <span
                        className={[
                          "rounded-full border px-2.5 py-1 text-[11px] font-semibold",
                          statusClass(item.status),
                        ].join(" ")}
                      >
                        {item.status || "-"}
                      </span>
                    </td>

                    <td className="px-5 py-4">{item.source_type || "-"}</td>
                    <td className="px-5 py-4">{fmtDate(item.created_at)}</td>
                    <td className="px-5 py-4">{fmtDate(item.received_at)}</td>

                    <td className="px-5 py-4">
                      <div className="flex justify-end gap-2">
                        <button
                          type="button"
                          onClick={() => openReceipt(item.id)}
                          className="inline-flex items-center gap-2 rounded-[10px] border border-[#f2c6cc] px-3 py-2 text-[12px] font-semibold text-slate-600"
                        >
                          <Eye size={14} />
                          View
                        </button>

                        <button
                          type="button"
                          onClick={() =>
                            warehouseInventoryService.printInboundReceipt(
                              item.id,
                              item.receipt_code || item.receiptCode
                            )
                          }
                          className="inline-flex items-center gap-2 rounded-[10px] bg-[#d86a78] px-3 py-2 text-[12px] font-semibold text-white"
                        >
                          <Download size={14} />
                          Print
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="px-5 py-8 text-center text-[14px] text-slate-500">
                    No inbound receipts found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Pagination
          page={receiptsPage}
          totalPages={receiptsTotalPages}
          onChange={setReceiptsPage}
        />
      </div>
    </>
  );
}